import React, { useEffect, useState } from "react";

const useIntersectionObserver = (
  ref: React.RefObject<HTMLElement>,
  options: IntersectionObserverInit = {}
): boolean => {
  const [inView, setInView] = useState<boolean>(false);

  useEffect(() => {
    const { threshold = 0, root = null, rootMargin = "0%" } = options;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold,
        root,
        rootMargin,
      }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }

    const cleanup = (): void => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
    return cleanup;
  }, [ref.current]);

  return inView;
};

export default useIntersectionObserver;
